import {
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_PRELOADER,
} from "./actionTypes";

import {
  layoutWidthTypes,
} from "../../constants/layout";

const INIT_STATE = {
  layoutWidth: layoutWidthTypes.FLUID,
  isPreloader: false,
  isMobile: false,
  leftMenu: false,
};

const Layout = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_PRELOADER:
      return {
        ...state,
        isPreloader: action.payload,
      };
    case CHANGE_LAYOUT_WIDTH:
      return {
        ...state,
        layoutWidth: action.payload,
      };
    case CHANGE_SIDEBAR_TYPE:
      return {
        ...state,
        leftSideBarType: action.payload.sidebarType,
      };
    default:
      return state;
  }
};

export default Layout;
